import helper from '../lib/helper'

const solutions = {
    animationtime: 700,
    timer: null,
    intervalTimer: 5000,
    init: function () {
        let $cardLists = $('.card-list')
        $cardLists.on('click', '.sol-card', solutions.slideToCard)

        if ($cardLists.length) {
            solutions.timer = new helper.timer(function () {
                let $activeCards = $('.sol-card.active-now')
                $activeCards.each((index, card) => {
                    // Play the cards rotation only when they are in the viewport
                    if (helper.isElementInViewport(card)) {
                        solutions.slideCards.call(card)
                    }
                })
            }, solutions.intervalTimer)
            $(window).on('load resize orientationchange scroll', function () {
                solutions.timer.reset(solutions.intervalTimer)
            })
        }
    },
    slideToCard: function () {
        let $target = $(this)
        solutions.slideCards.apply($target)
        if (!$target.hasClass('active-now')) {
            setTimeout(function () {
                solutions.slideCards.apply($target)
            }, solutions.animationtime)
        }
        solutions.timer.reset(solutions.intervalTimer)
    },
    slideCards: function (ev) {
        let $currentList = $(this).parent().css('pointer-events', 'none')
        let $cards = $currentList.children()

        let $firstCard = $cards
            .last()
            .clone()
            .addClass('cloned-card')
            .removeClass('active-now')
        $firstCard.find('img').removeAttr('style')
        $firstCard.prependTo($currentList)
        $cards
            .last()
            .addClass('transform-this')
            .prev()
            .addClass('active-now')
            .addClass('sliding')
        setTimeout(function () {
            $cards.last().remove()
            $cards.removeClass('sliding')
            $firstCard.removeClass('cloned-card')
            $currentList.css('pointer-events', 'all')
        }, solutions.animationtime)
    },
}

solutions.init()
